'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_CredentialTables$$anon$25() {
}
export { $c_Lpresto_CredentialTables$$anon$25 as $c_Lpresto_CredentialTables$$anon$25 };
$p = $c_Lpresto_CredentialTables$$anon$25.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_CredentialTables$$anon$25;
/** @constructor */
function $h_Lpresto_CredentialTables$$anon$25() {
}
export { $h_Lpresto_CredentialTables$$anon$25 as $h_Lpresto_CredentialTables$$anon$25 };
$h_Lpresto_CredentialTables$$anon$25.prototype = $p;
$p.b6 = (function(_$74) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(_$74, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$75) => _$75.iw.xf)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_math_Ordering$String$());
});
var $d_Lpresto_CredentialTables$$anon$25 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_CredentialTables$$anon$25, "presto.CredentialTables$$anon$25", ({
  FJ: 1,
  G: 1
}));
export { $d_Lpresto_CredentialTables$$anon$25 as $d_Lpresto_CredentialTables$$anon$25 };
//# sourceMappingURL=presto.-Credential-Tables$$anon$25.js.map
